{
  "comment": "M4 strategic core (spec §3.5, §4.9, §13, §18). clock: fine tick 1 s, slow tick 60 s, faction day 600 s, a combat round every 10 s, opportunity tables every 10 s, 4 coarse substeps per catch-up day, the faction-day work sliced over the first daySlices fine ticks of a day, advance() every advanceIntervalS on the main thread, dev warp up to warpMax. caps: store capacities allocated once by allocateState (pool 4,096 agents; routes hold maxHops systems; rings and the heap are powers of two), maxAgents is the population cap for orders. catchUp: the offline cap (8 h) and the hidden-tab threshold. rollupDays: day rollups kept; wireKeep: Wire items kept in memory (the save keeps wireSaved); historyDays: gate stability history. Starting values, tune freely. E15 tuning pass (D-TBD: M4 tuning pass): 10 coarse substeps per day (60 s) keep the coarse catch-up within the spec §19 equivalence tolerances; with 4, trader and miner decisions on 150 s-old opportunity tables moved raw-ore stock and ships built out of tolerance. M6 (plan P0): daySlices 18 (M5 16 + the fleet and corp slices), and the player caps (M6 spec §9): at most playerShips ships and playerStations stations. M7 (plan S16): daySlices 19 (+ the story slice); story: the M7 worker store capacities (grievance terms, restored derelicts, titles, challenges, story ships) and incomeDays, the Tethys income window the stipend reads.",
  "clock": {
    "fineS": 1,
    "slowS": 60,
    "dayS": 600,
    "combatRoundS": 10,
    "opportunityRefreshS": 10,
    "coarseSubsteps": 10,
    "daySlices": 19,
    "advanceIntervalS": 0.25,
    "warpMax": 120
  },
  "caps": {
    "maxAgents": 3000,
    "poolCapacity": 4096,
    "maxHops": 12,
    "maxStations": 320,
    "linesPerStation": 8,
    "maxNodes": 2048,
    "maxFields": 256,
    "maxGroups": 512,
    "groupMembers": 8,
    "maxOrders": 1024,
    "maxWrecks": 512,
    "maxSites": 64,
    "maxEncounters": 128,
    "encounterSide": 16,
    "factionCapacity": 16,
    "heapCapacity": 8192,
    "eventRing": 8192,
    "notableRing": 4096,
    "playerShips": 50,
    "playerStations": 10
  },
  "story": { "grievances": 16, "restored": 64, "titles": 8, "challenges": 32, "ships": 16, "incomeDays": 10 },
  "catchUp": { "capS": 28800, "hiddenResumeS": 300 },
  "rollupDays": 10,
  "wireKeep": 200,
  "wireSaved": 50,
  "historyDays": 30
}
